import React from 'react';
import { Row, Col } from 'react-bootstrap';

const CropItem = ({ id, name, userCount, totalUsers, barColor }) => {
    const percentage = totalUsers > 0 ? (userCount / totalUsers) * 100 : 0;

    const rankCircleStyle = {
        backgroundColor: '#E8F5E9',
        color: barColor,
        borderRadius: '50px',
        width: '32px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        fontSize: '0.8rem',
        flexShrink: 0,
    };

    return (
        <div className="mb-3">
            <Row className="align-items-center g-2">
                <Col xs={8} className="d-flex align-items-center">
                    <span className="fw-medium">{name}</span>
                </Col>
                <Col xs={1} className="text-end">
                    <div className='d-flex gap-2'>
                        <div style={rankCircleStyle}>{userCount}</div>
                        <span>Users</span>
                    </div>
                </Col>
            </Row>

            <Row className="g-0 mt-1">
                <Col xs={11}>
                    <div style={{ height: '6px', backgroundColor: '#f0f0f0', borderRadius: '4px' }}>
                        <div
                            style={{
                                width: `${percentage}%`,
                                height: '100%',
                                backgroundColor: barColor,
                                borderRadius: '4px'
                            }}
                        />
                    </div>
                </Col>
                <Col xs={1} />
            </Row>
        </div>
    );
};

const SubscriptionPlan = ({ subscriptionData = [] }) => {
    console.log(subscriptionData);
    // Colors for different subscription plans
    const colorPalette = ['#342D56', '#CBA370', '#4CAF50', '#2196F3', '#FF9800', '#9C27B0'];
    // Calculate total users across all subscriptions
    const totalUsers = subscriptionData.reduce((sum, item) => sum + item.UserCount, 0);

    return (
        <div className="col-xxl-6 col-xl-12">
            <div className="card h-100">
                <div className="card-body">
                    <h6 className="text-lg mb-20 text-capitalize" style={{ color: '#1B5E20', fontWeight: 'bold' }}>
                        Subscription Plan Distribution
                    </h6>

                    <div className="d-flex flex-column gap-10">
                        {subscriptionData.length > 0 ? (
                            subscriptionData.map((plan, index) => (
                                <CropItem
                                    key={index}
                                    id={index + 1}
                                    name={plan.SubscriptionName || 'Unknown'}
                                    userCount={plan.UserCount}
                                    totalUsers={totalUsers}
                                    barColor={colorPalette[index % colorPalette.length]}
                                />
                            ))
                        ) : (
                            <div className="text-center text-muted py-3">
                                No subscription data available
                            </div>
                        )}
                    </div>

                    {subscriptionData.length > 0 && (
                        <div className="mt-3 pt-3 border-top">
                            <div className="d-flex justify-content-between">
                                <span className="text-muted small">Total Users:</span>
                                <span className="fw-bold">{totalUsers}</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SubscriptionPlan;